import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { AddCsvFile } from '../../../../../../../../components/csv-import/ui/components/add-csv-file';
import { useImportContext } from '../../../../../../../../components/csv-import/ui/components/import-context';
import { ImportDescription } from '../../../../../../../../components/csv-import/ui/components/import-description';
import { InitErrors } from '../../../../../../../../components/csv-import/ui/components/init-errors/init-errors';
import { MappingList } from '../../../../../../../../components/csv-import/ui/components/mapping-list/mapping-list';
import { StepHeader } from '../../../../../../../../components/csv-import/ui/components/step-header/step-header';
import { StepSuspense } from '../../../../../../../../components/csv-import/ui/components/step-suspense/step-suspense';
import { SimpleDropdown } from '../../../../../../../../components/simple-dropdown';
import { linkIDs } from '../../../../../../../../services/link-service/links';
import Global from '../../../../../../../../store/global-selectors';
import { WorkflowSteps } from '../../../../../../../../tracking/use-workflow-tracking';
import { SET_INVENTORY_WAREHOUSE } from '../reducer';
import { messages } from './messages';
import styles from './styles.module.less';

const exampleFile = '/s3/marketplaces/shipstation/LocationImportSample.csv';

const warehouseSelector = createSelector([Global.selectSellerInventoryWarehouses], (warehouses) => {
  return warehouses.map((warehouse) => ({
    key: warehouse.inventoryWarehouseId,
    name: warehouse.name,
    ...warehouse,
  }));
});

export const ConfigStepBody = () => {
  const { isGetMappingsLoading, isInitImportLoading, form, trackProcess, dispatch } = useImportContext();

  const warehouses = useSelector(warehouseSelector);

  const changeInventoryWarehouse = (inventoryWarehouse) => {
    dispatch({ type: SET_INVENTORY_WAREHOUSE, inventoryWarehouse });

    trackProcess(WorkflowSteps.CSV_IMPORT_CHANGE_CUSTOM_PROPERTY, {
      property: 'inventoryWarehouse',
      value: inventoryWarehouse,
    });
  };

  return (
    <StepSuspense isLoading={isGetMappingsLoading || isInitImportLoading}>
      <StepHeader>
        <FormattedMessage {...messages.uploadFile} />
      </StepHeader>
      <ImportDescription articleId={linkIDs.InventoryInShipstation} file={exampleFile} message={messages.helpContentText} />
      <InitErrors />
      <AddCsvFile name='location-import' />
      <FlexRow className={styles['dropdown-container']}>
        <FlexColumn className={styles['dropdown-wrapper']}>
          <Text className={styles['dropdown-title']} textType={TextType.Label} value={messages.selectInventoryWarehouseHeader} />
          <div className={styles['dropdown-menu']}>
            <SimpleDropdown
              defaultTitle={<FormattedMessage {...messages.selectInventoryWarehouse} />}
              dropdownMenuShouldHaveWidthOfButton
              items={warehouses}
              onItemSelected={changeInventoryWarehouse}
              selectedItemKey={form.inventoryWarehouse}
            />
          </div>
        </FlexColumn>
        <FlexColumn className={styles['dropdown-wrapper']}>
          <MappingList menuClassName={styles['dropdown-menu']} />
        </FlexColumn>
      </FlexRow>
    </StepSuspense>
  );
};
